import { Outlet } from 'react-router-dom'
import { SidebarProvider } from '@/components/providers/sidebar-provider'
import StaffSidebar from '@/components/navigation/staff-sidebar'
import { UserMenu } from '@/components/layout/user-menu'
import { ThemeToggle } from '@/components/layout/theme-toggle'
import CheckInOut from '@/components/CheckInOut'
import { useEffect, useState } from 'react'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

// Staff layout - similar structure to Dashboard but with different navigation
export default function StaffLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true)

  useEffect(() => {
    // Add any staff-specific initialization here
    document.body.classList.add('staff-layout')
    return () => {
      document.body.classList.remove('staff-layout')
    }
  }, [])

  return (
    <SidebarProvider>
      <div className="relative flex h-screen overflow-hidden bg-background">
        {/* Sidebar with staff-specific navigation */}
        <aside
          className={`${
            sidebarOpen ? 'w-64' : 'w-16'
          } flex flex-col bg-card border-r border-border transition-all duration-300`}
        >
          {/* Sidebar Header */}
          <div className="flex h-16 items-center justify-between px-4 border-b">
            {sidebarOpen && (
              <h2 className="text-lg font-semibold">Staff Portal</h2>
            )}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="ml-auto"
            >
              {sidebarOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
            </Button>
          </div>

          {/* Navigation */}
          <StaffSidebar isCollapsed={!sidebarOpen} />
        </aside>

        {/* Main Content Area */}
        <div className="flex flex-1 flex-col overflow-hidden">
          {/* Header */}
          <header className="flex h-16 items-center justify-between border-b bg-card px-6">
            <div className="flex items-center space-x-4">
              <h1 className="text-2xl font-semibold">InstaDev Staff</h1>
            </div>
            <div className="flex items-center gap-2">
              <CheckInOut variant="full" size="sm" showClock={true} showStatus={true} />
              <ThemeToggle />
              <UserMenu />
            </div>
          </header>

          {/* Page Content */}
          <main className="flex-1 overflow-y-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  )
}